import { ClientWebsitesListItem } from '@va/aaas/shared/api-client';
import { VisaApiResponse } from '@visitor-analytics/3as-sdk';

export const stpCounterWebsitesMapper = (response: VisaApiResponse<ClientWebsitesListItem[]>) => {
  return response.payload.map((website) => ({
    id: website.id,
    limit: website.subscription?.consumption.stpLimit ?? -1,
    consumed: website.subscription?.consumption.stpConsumed ?? 0,
    domain: website.domain,
  }));
};
